import { render, staticRenderFns } from "./BookThumbnail.vue?vue&type=template&id=7158f308&"
import script from "./BookThumbnail.vue?vue&type=script&lang=js&"
export * from "./BookThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports